import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import DashboardTablePagination from '../Paginations/DashboardTablePagination';

const AcademiaDashboardTable = ({
  data,
  columns,
  showPagination,
}: {
  data: Array<any>;
  columns: any;
  showPagination?: boolean;
}) => {
  // integration of react hooks here
  const [currentPage, setCurrentPage] = useState<number>(1);

  // integration of tanstack table hooks here
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  // rendering custom table component here
  return (
    <div>
      <AnimatePresence mode='wait'>
        <motion.div
          key={currentPage}
          initial={{ y: -10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 10, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className='overflow-auto'
        >
          <table className='w-full min-w-[500px]'>
            <thead className='border-b-2 border-dashed border-base-dark-green'>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr
                  key={headerGroup.id}
                  className='[&>th]:font-medium [&>th]:text-base-dark-green [&>th]:pb-2'
                >
                  {headerGroup.headers.map((header) => (
                    <th key={header.id}>
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id} className='text-center [&>td]:py-1'>
                  {row.getVisibleCells().map((cell) => (
                    <td
                      title={cell.getValue() as string}
                      key={cell.id}
                      className='max-w-[150px] truncate'
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>
      </AnimatePresence>

      {showPagination ? (
        <div className='mt-3 flex items-center justify-center md:justify-end'>
          <DashboardTablePagination
            totalPages={5}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      ) : null}
    </div>
  );
};

export default AcademiaDashboardTable;
